// Notification sound using an HTML Audio element with a tiny inline WAV.
// This is more reliable than AudioContext on iOS WebViews.

// Tiny WAV: 880Hz sine wave, 150ms, 22050Hz sample rate, mono 8-bit
function generateDingWav(): string {
  const sampleRate = 22050;
  const duration = 0.15;
  const freq = 880;
  const numSamples = Math.floor(sampleRate * duration);
  const dataSize = numSamples;
  const fileSize = 44 + dataSize;

  const buf = new ArrayBuffer(fileSize);
  const view = new DataView(buf);

  // WAV header
  const writeStr = (offset: number, str: string) => {
    for (let i = 0; i < str.length; i++) view.setUint8(offset + i, str.charCodeAt(i));
  };
  writeStr(0, "RIFF");
  view.setUint32(4, fileSize - 8, true);
  writeStr(8, "WAVE");
  writeStr(12, "fmt ");
  view.setUint32(16, 16, true); // chunk size
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, 1, true); // mono
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate, true); // byte rate
  view.setUint16(32, 1, true); // block align
  view.setUint16(34, 8, true); // bits per sample
  writeStr(36, "data");
  view.setUint32(40, dataSize, true);

  // Generate samples with fade-out
  for (let i = 0; i < numSamples; i++) {
    const t = i / sampleRate;
    const envelope = 1 - (t / duration); // linear fade
    const sample = Math.sin(2 * Math.PI * freq * t) * envelope * 0.1;
    view.setUint8(44 + i, Math.floor((sample + 1) * 127.5));
  }

  // Convert to base64 data URI
  const bytes = new Uint8Array(buf);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return "data:audio/wav;base64," + btoa(binary);
}

let dingUrl: string | null = null;
let audioElement: HTMLAudioElement | null = null;

function ensureAudio(): HTMLAudioElement {
  if (!dingUrl) {
    dingUrl = generateDingWav();
  }
  if (!audioElement) {
    audioElement = new Audio(dingUrl);
    audioElement.volume = 0.1;
  }
  return audioElement;
}

// Call on first user interaction to "warm up" audio on iOS
export function unlockAudio() {
  const audio = ensureAudio();
  // Play and immediately pause — unlocks audio on iOS
  const p = audio.play();
  if (p) {
    p.then(() => {
      audio.pause();
      audio.currentTime = 0;
    }).catch(() => {});
  }
}

export function playDing() {
  try {
    const audio = ensureAudio();
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch {
    // Not available
  }
}

export function vibrate() {
  if (navigator.vibrate) {
    navigator.vibrate(200);
  }
}

export function notifyIncoming() {
  playDing();
  vibrate();
}
